import { Navigate, type RouteObject, useLocation, useParams } from "react-router";
import type { AppModule, RouteHandle } from "../types";

function InviteAlias() {
  const { token = "" } = useParams();
  const { search, hash } = useLocation();
  return <Navigate replace to={`/invitation/${encodeURIComponent(token)}/join-workspace${search}${hash}`} />;
}

function ToLogin() {
  const { search } = useLocation();
  return <Navigate replace to={`/login${search}`} />;
}

function ToSignup() {
  return <Navigate replace to="/signup" />;
}

const open: RouteHandle = { guestOnly: false };

const authRoutes: RouteObject[] = [
  {
    path: "/login",
    handle: { title: "Log in" },
    lazy: () => import("./LoginPage").then((m) => ({ Component: m.LoginPage })),
  },
  {
    path: "/signup",
    handle: { title: "Sign up" },
    lazy: () => import("./SignupPage").then((m) => ({ Component: m.SignupPage })),
  },
  {
    path: "/forgot-password",
    handle: { title: "Forgot password" },
    lazy: () => import("./ForgotPasswordPage").then((m) => ({ Component: m.ForgotPasswordPage })),
  },
  {
    path: "/reset-password/:token",
    handle: { ...open, title: "Create new password" },
    lazy: () => import("./ResetPasswordPage").then((m) => ({ Component: m.ResetPasswordPage })),
  },
  {
    path: "/invitation/:token/join-workspace",
    handle: { ...open, title: "Join workspace" },
    lazy: () => import("./InvitePage").then((m) => ({ Component: m.InvitePage })),
  },
  { path: "/invite/:token", handle: open, element: <InviteAlias /> },
  // OTP/SSO/subdomain flows are not supported; send them to the password login (routes.md 1.9).
  ...["/login/otp", "/login/otp/confirm-identity", "/login/confirm-identity", "/login/sso", "/login-owner"].map(
    (path): RouteObject => ({ path, handle: open, element: <ToLogin /> }),
  ),
  { path: "/account-not-found", handle: open, element: <ToSignup /> },
];

export const shellAuthModule: AppModule = {
  name: "shell-auth",
  routes: {
    auth: authRoutes,
    handoff: [
      {
        path: "/logout",
        handle: { title: "Log out" },
        lazy: () => import("./LogoutPage").then((m) => ({ Component: m.LogoutPage })),
      },
    ],
  },
};
